import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { retry } from 'rxjs/operators';

const HTTP_GATEWAY_TIMEOUT = 504;
const RETRY_DELAYS_MS = [1000, 2000, 4000];

@Injectable()
export class HttpRetryInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: RETRY_DELAYS_MS.length,
        delay: (error: unknown, retryCount: number) => {
          if (!(error instanceof HttpErrorResponse) || error.status !== HTTP_GATEWAY_TIMEOUT) {
            return throwError(() => error);
          }

          return timer(RETRY_DELAYS_MS[retryCount - 1]);
        }
      })
    );
  }
}